(function(root) {
  'use strict';

  var MM_PER_INCH = 25.4;
  var INCH_MIN = 0.5;
  var INCH_MAX = 12;
  var MM_MIN = 12.7;
  var MM_MAX = 304.8;
  var INCH_SCALE = 1000;

  function trim(value, decimalPlaces) {
    var numeric = Number(value);
    if (!Number.isFinite(numeric)) return '';
    return numeric.toFixed(decimalPlaces).replace(/\.?0+$/, '');
  }

  function decimalPlaces(value) {
    var text = String(value == null ? '' : value).trim();
    if (!/^\d+(?:\.\d+)?$/.test(text)) return null;
    var decimal = text.indexOf('.');
    return decimal === -1 ? 0 : text.length - decimal - 1;
  }

  function normalizeInches(value) {
    var numeric = Number(value);
    var places = decimalPlaces(value);
    if (!Number.isFinite(numeric) || places === null || places > 3 ||
        numeric < INCH_MIN || numeric > INCH_MAX) return null;
    return Math.round(numeric * INCH_SCALE) / INCH_SCALE;
  }

  function millimetersToCanonicalInches(value) {
    var numeric = Number(value);
    if (!Number.isFinite(numeric) || numeric < MM_MIN || numeric > MM_MAX) return null;
    return Math.round((numeric / MM_PER_INCH) * INCH_SCALE) / INCH_SCALE;
  }

  function inchesToMillimeters(value) {
    var numeric = Number(value);
    if (!Number.isFinite(numeric)) return null;
    return numeric * MM_PER_INCH;
  }

  function normalizePair(unit, width, height) {
    var widthIn = unit === 'mm'
      ? millimetersToCanonicalInches(width)
      : normalizeInches(width);
    var heightIn = unit === 'mm'
      ? millimetersToCanonicalInches(height)
      : normalizeInches(height);
    if (widthIn === null || heightIn === null || widthIn * heightIn > 144) return null;
    return {
      widthIn: widthIn,
      heightIn: heightIn,
      enteredWidth: trim(width, 3),
      enteredHeight: trim(height, 3),
      unit: unit === 'mm' ? 'mm' : 'in'
    };
  }

  function displayFromCanonical(unit, inches) {
    return unit === 'mm'
      ? trim(inchesToMillimeters(inches), 3)
      : trim(inches, 3);
  }

  root.ZUG_ROLL_LABEL_SIZE_UNITS = {
    MM_PER_INCH: MM_PER_INCH,
    INCH_MIN: INCH_MIN,
    INCH_MAX: INCH_MAX,
    MM_MIN: MM_MIN,
    MM_MAX: MM_MAX,
    trim: trim,
    decimalPlaces: decimalPlaces,
    normalizeInches: normalizeInches,
    millimetersToCanonicalInches: millimetersToCanonicalInches,
    inchesToMillimeters: inchesToMillimeters,
    normalizePair: normalizePair,
    displayFromCanonical: displayFromCanonical
  };
})(typeof window !== 'undefined' ? window : this);
